import { IStore } from '../../../common/store';
import { ValuationPriceTypes } from '../../../common/enum/ValuationPriceTypes';
import IPlainPartExchange from '../../../common/model/IPlainPartExchange';
import IPlainPriceEvaluationInterface from '../../../common/model/IPlainPriceEvaluationInterface';

const getPartExchangeReducer = (state: IStore) => {
  return state.customiseCombinedReducer.partExchangeReducer;
};

const getPriceEvaluation = (partExchangeReducer: any) => {
  return (
    (partExchangeReducer.partExchange as IPlainPartExchange)?.valuation.priceEvaluations.find(
      (priceEvaluation: IPlainPriceEvaluationInterface) => {
        return priceEvaluation.evaluationType === ValuationPriceTypes.FINAL;
      },
    ).evaluationValue || 0
  );
};

const partExchangeSelectors = {
  getPartExchange: (state: IStore) => getPartExchangeReducer(state).partExchange,
  getPartExchangeValuation: (state: IStore) => getPriceEvaluation(getPartExchangeReducer(state)),
  getPartExchangeManufactureYear: (state: IStore) =>
    getPartExchangeReducer(state).partExchange?.vehicle.manufactureYear,
  getPartExchangeTitle: (state: IStore) =>
    getPartExchangeReducer(state).partExchange
      ? `${getPartExchangeReducer(state).partExchange?.vehicle.manufacturer} ${
          getPartExchangeReducer(state).partExchange?.vehicle.model
        }`
      : undefined,
};

export default partExchangeSelectors;
